import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    formWrapper: {
        width: '100%',
        maxWidth: '500px !important',
        display: 'flex',
        flexDirection: 'column',    
        alignItems: 'center',
        justifyContent: 'center',
        margin: 'auto'
      },
}))

export default useStyles
